export default [
  {
    path: "",
    component: () => import("@/views/smart-audiences/SmartAudiencesIndex.vue"),
  },
  {
    path: "new",
    component: () =>
      import("@/views/smart-audiences/edit/SmartAudiencesGeneral.vue"),
  },
  {
    path: ":draftId",
    component: () =>
      import("@/views/smart-audiences/edit/SmartAudiencesGeneral.vue"),
  },
]
